import axios from 'axios';
import { Job, GetMatchingJobsRequest, GetMatchingJobsResponse, CreateAdHocJobRequest, CreateAdHocJobResponse } from '../types/jobs';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const jobsApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
jobsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export class JobsService {
  static async getMatchingJobs(request: GetMatchingJobsRequest): Promise<GetMatchingJobsResponse> {
    try {
      const response = await jobsApi.get('/jobs/matching', {
        params: request
      });
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        jobs: [],
        matchCount: 0
      };
    }
  }

  static async createAdHocJob(request: CreateAdHocJobRequest): Promise<CreateAdHocJobResponse> {
    try {
      const response = await jobsApi.post('/jobs/ad-hoc', request);
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        workRecordId: '',
        jobType: 'ad-hoc',
        checkInTime: ''
      };
    }
  }

  static async getProviderJobs(providerId: string, date?: string): Promise<{ success: boolean; jobs: Job[] }> {
    try {
      const params: any = { providerId };
      if (date) {
        params.date = date;
      }
      
      const response = await jobsApi.get('/jobs/provider', { params });
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        jobs: []
      };
    }
  }

  static async getTodayJobs(providerId: string): Promise<{ success: boolean; jobs: Job[] }> {
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    return this.getProviderJobs(providerId, today);
  }

  static async getWeekJobs(providerId: string): Promise<{ success: boolean; jobs: Job[] }> {
    try {
      const response = await jobsApi.get('/jobs/week', {
        params: { providerId }
      });
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        jobs: []
      };
    }
  }
} 